import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { View } from 'react-native';
import { selectPlansPinInCurrentPlan } from 'store/plan/selectors';

import { PlanLoaded } from 'store/plan/types';
import { Pin } from './Pin';

export type PinsRef = {
  scaleChange: (scale: number) => void;
  panChange: (arg: { x: number; y: number }) => void;
};

type Props = {
  width: number;
  height: number;
  scale?: number;
  image?: PlanLoaded['image'];
  onPinMove?: ({ x, y }: { x: number; y: number }) => void;
  onPinPress?: (id: string) => void;
  onPinPressUp?: (id: string) => void;
  ref: React.Ref<PinsRef>;
};

export const PinsMain = ({
  height,
  onPinMove,
  onPinPress,
  onPinPressUp,
  width,
  scale = 1,
  image,
  ref,
}: React.PropsWithChildren<Props>) => {
  const pin = useSelector(selectPlansPinInCurrentPlan);

  const [internalScale, setScale] = React.useState(scale);
  const [internalPan, setPan] = React.useState({ x: 0, y: 0 });

  React.useImperativeHandle(
    ref,
    () => ({
      scaleChange: setScale,
      panChange: setPan,
    }),
    [],
  );

  if (!pin) {
    return null;
  }

  const finalWidth = Math.round(width * internalScale);
  const finalHeight = Math.round(height * internalScale);

  return (
    <View
      style={{
        width: finalWidth,
        height: finalHeight,
        position: 'absolute',
        top: 'auto',
        left: 'auto',
        transform: [
          { translateY: internalPan.y * internalScale },
          { translateX: internalPan.x * internalScale },
        ],
      }}
      pointerEvents="box-none"
    >
      <Pin
        id="main"
        onMoved={onPinMove}
        onPress={onPinPress}
        onPressUp={onPinPressUp}
        text=""
        image={image}
        canvasWidth={finalWidth}
        canvasHeight={finalHeight}
        x={pin.x}
        y={pin.y}
        active
        canHaveLoupe
      />
    </View>
  );
};
